import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, createTextVNode as _createTextVNode, vModelRadio as _vModelRadio, withModifiers as _withModifiers, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "formulario-modelo" }
const _hoisted_2 = { class: "superior" }
const _hoisted_3 = { class: "header-flex" }
const _hoisted_4 = {
  key: 0,
  class: "ctx-strip"
}
const _hoisted_5 = {
  key: 0,
  class: "ctx-version"
}
const _hoisted_6 = {
  key: 0,
  class: "ctx-ruta-tipo"
}
const _hoisted_7 = {
  key: 1,
  class: "ctx-ruta-ordinal"
}
const _hoisted_8 = { class: "ctx-ruta-nombre" }
const _hoisted_9 = {
  key: 2,
  class: "ctx-ruta-nodo ctx-indicador-row"
}
const _hoisted_10 = { class: "ctx-indicador" }
const _hoisted_11 = { class: "contenedor-tabla" }
const _hoisted_12 = {
  key: 0,
  class: "info"
}
const _hoisted_13 = {
  key: 1,
  class: "lista-tabla"
}
const _hoisted_14 = { class: "doc-celda" }
const _hoisted_15 = {
  key: 0,
  class: "rename-row"
}
const _hoisted_16 = ["onKeyup"]
const _hoisted_17 = ["onClick"]
const _hoisted_18 = ["href"]
const _hoisted_19 = ["href", "title"]
const _hoisted_20 = {
  key: 1,
  class: "badge-origen externo"
}
const _hoisted_21 = {
  key: 2,
  class: "badge-formato"
}
const _hoisted_22 = {
  key: 2,
  class: "badge-origen desconocido"
}
const _hoisted_23 = ["href"]
const _hoisted_24 = { key: 4 }
const _hoisted_25 = { class: "acciones-ficha" }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = ["onClick"]
const _hoisted_28 = ["disabled", "onChange"]
const _hoisted_29 = ["onClick"]
const _hoisted_30 = {
  key: 2,
  class: "mensaje-vacio"
}
const _hoisted_31 = { class: "fila" }
const _hoisted_32 = { class: "radio-group" }
const _hoisted_33 = ["value"]
const _hoisted_34 = { class: "fila" }
const _hoisted_35 = ["disabled"]
const _hoisted_36 = { key: 0 }
const _hoisted_37 = { key: 1 }
const _hoisted_38 = { class: "fila" }
const _hoisted_39 = ["disabled"]
const _hoisted_40 = {
  key: 0,
  class: "hint"
}
const _hoisted_41 = { class: "fila" }
const _hoisted_42 = ["disabled"]
const _hoisted_43 = { class: "fila" }
const _hoisted_44 = ["disabled"]
const _hoisted_45 = { class: "fila" }
const _hoisted_46 = ["disabled"]
const _hoisted_47 = { class: "botones" }

import { onMounted, ref, watch, computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useGestionFichas } from '@/store/GestionFichas'
import MensajeConfirmacion from '@/components/MensajeConfirmacion.vue'
import MensajeFlotante from '@/components/MensajeFlotante.vue'
import type { Ficha } from '@/interfaces/Ficha'

interface RutaNodo { tipo: string; ordinal: string; nombre: string }


export default /*@__PURE__*/_defineComponent({
  __name: 'FichaDocumental',
  props: {
    idInstrumento: { default: null },
    nombreVersion: {},
    rutaComponente: {},
    nombreIndicador: {}
  },
  emits: ["cerrar"],
  setup(__props: any, { emit: __emit }) {

/**
 * Ficha de evidencia documental con su adjunto.
 *
 * ── Enrutado ─────────────────────────────────────────────────────
 *   `/ficha-documental` (FichaDocumental) — permiso `evidencias.subir`
 *
 * Componente de presentación. Recibe sus datos por props o del store del módulo.
 */

const props = __props
const emit = __emit

const fichaStore = useGestionFichas()
const route = useRoute()
const router = useRouter()
const loading = ref(false)
const subiendo = ref<number | null>(null)
const renombrandoId = ref<number | null>(null)
const fichasRecienCreadas = ref<number[]>([])
const nuevoNombre = ref('')

function iniciarRenombrar(f: Ficha) {
  renombrandoId.value = f.id_ficha!
  nuevoNombre.value = f.nombre_visible ?? f.nombre_documento ?? ''
}

function cancelarRename() {
  renombrandoId.value = null
  nuevoNombre.value = ''
}

async function guardarNombre(idFicha: number) {
  const nombre = nuevoNombre.value.trim()
  if (!nombre) { cancelarRename(); return }
  const resultado = await fichaStore.actualizarFicha(idFicha, { nombre_documento: nombre })
  if (resultado) {
    mostrarMensaje('Nombre actualizado', 'positivo')
    await cargarFichas()
  } else {
    mostrarMensaje('Error al actualizar el nombre', 'error')
  }
  cancelarRename()
}
const archivoSeleccionado = ref<File | null>(null)
const fileInputRef = ref<HTMLInputElement | null>(null)

const fichasLocales = ref<Ficha[]>([])

const fichasUnicas = computed(() => {
  const vistas = new Set<number>()
  return fichasLocales.value.filter(f => {
    if (!f.id_ficha || vistas.has(f.id_ficha)) return false
    vistas.add(f.id_ficha)
    return true
  })
})


const mensajeVisible = ref(false)
const mensajeTexto = ref('')
const mensajeTipo = ref<'positivo' | 'error'>('positivo')

function mostrarMensaje(texto: string, tipo: 'positivo' | 'error') {
  mensajeTexto.value = texto
  mensajeTipo.value = tipo
  mensajeVisible.value = true
}

const estados = {
  existe: '🟢 Existe',
  actualizable: '🟡 Actualizable',
  no_existe: '🔴 No existe'
}

const formData = ref<Omit<Ficha, 'id_ficha' | 'tipo'>>({
  id_instrumento: 0,
  estado: '',
  documento: '',
  fuente_datos: '',
  detalle: '',
  observaciones: '',
  descripcion: '',
  fecha_registro: new Date().toISOString().split('T')[0]
})

// Control de confirmación y toast
const showConfirmacion = ref(false)
const tituloConfirmacion = ref('')
const mensajeConfirmacion = ref('')
let accionPendiente: (() => Promise<void>) | null = null

function parseInstrumentoId(input: unknown): number | null {
  if (input === null || input === undefined) return null
  const raw = Array.isArray(input) ? input[0] : input
  const value = typeof raw === 'string' ? Number(raw) : typeof raw === 'number' ? raw : Number(String(raw))
  return Number.isFinite(value) && value > 0 ? value : null
}

async function cargarFichas() {
  const id = parseInstrumentoId(
    props.idInstrumento ??
    (route.query as any).id_instrumento ??
    (route.params as any).id_instrumento ??
    (route.params as any).id
  )
  if (!id) {
    mostrarMensaje('No se encontró id_instrumento en la URL.', 'error')
    return
  }

  formData.value.id_instrumento = id
  loading.value = true
  try {
    fichasLocales.value = (await fichaStore.listarFichas({ id_instrumento: id, tipo: 'documental' })) ?? []
  } finally {
    loading.value = false
  }
}

onMounted(cargarFichas)

watch(() => props.idInstrumento, (val) => {
  if (val != null) cargarFichas()
})

function estadoClass(estado: string | undefined) {
  return `semaforo-${estado}`
}

async function guardarFicha() {
  if (!formData.value.id_instrumento || formData.value.id_instrumento <= 0) {
    mostrarMensaje('id_instrumento es requerido para crear la ficha.', 'error')
    return
  }

  // Validar que estado esté seleccionado
  if (!formData.value.estado) {
    mostrarMensaje('Por favor seleccione un estado', 'error')
    return
  }

  // Validar campos requeridos según estado
  if (formData.value.estado !== 'no_existe') {
    if (!archivoSeleccionado.value && !formData.value.documento?.trim()) {
      mostrarMensaje('Suba un archivo o ingrese un enlace del documento', 'error')
      return
    }
    if (!formData.value.fuente_datos?.trim()) {
      mostrarMensaje('La fuente de datos es requerida', 'error')
      return
    }
  }

  // Preparar confirmación
  tituloConfirmacion.value = 'Guardar Ficha Documental'
  mensajeConfirmacion.value = '¿Está seguro de que desea guardar esta ficha?'
  
  accionPendiente = async () => {
    formData.value.descripcion = formData.value.detalle?.trim() || formData.value.estado || 'N/A'
    if (!formData.value.fecha_registro) {
      formData.value.fecha_registro = new Date().toISOString().split('T')[0]
    }

    // Si hay archivo seleccionado, usar placeholder para documento
    const docValue = archivoSeleccionado.value
      ? 'pendiente-upload'
      : (formData.value.documento?.trim() || 'sin-documento')

    const payload: Omit<Ficha, 'id_ficha'> = {
      ...formData.value,
      documento: docValue,
      tipo: 'documental'
    }

    const resultado = await fichaStore.crearFicha(payload)

    if (resultado.ok && resultado.ficha) {
      if (resultado.ficha.id_ficha) fichasRecienCreadas.value.push(resultado.ficha.id_ficha)
      // Si hay archivo, subirlo a Cloudinary
      if (archivoSeleccionado.value && resultado.ficha.id_ficha) {
        mostrarMensaje('Ficha creada. Subiendo archivo...', 'positivo')
        const uploadResult = await fichaStore.uploadArchivo(resultado.ficha.id_ficha, archivoSeleccionado.value)
        if (uploadResult.ok) {
          mostrarMensaje('Ficha guardada y archivo subido exitosamente', 'positivo')
        } else {
          mostrarMensaje(uploadResult.error || 'Ficha creada pero error al subir archivo', 'error')
        }
      } else {
        mostrarMensaje('Ficha documental guardada exitosamente', 'positivo')
      }
      archivoSeleccionado.value = null
      limpiarFormulario()
      await cargarFichas()
    } else {
      mostrarMensaje(resultado.error || 'Error al guardar la ficha', 'error')
    }
  }

  showConfirmacion.value = true
}

function limpiarFormulario() {
  formData.value = {
    id_instrumento: 0,
    estado: '',
    documento: '',
    fuente_datos: '',
    detalle: '',
    observaciones: '',
    descripcion: '',
    fecha_registro: new Date().toISOString().split('T')[0]
  }
}

function abrirConfirmacionEliminar(id: number | undefined) {
  if (!id) return

  tituloConfirmacion.value = 'Eliminar Ficha'
  mensajeConfirmacion.value = '¿Está seguro de que desea eliminar esta ficha? Esta acción no se puede deshacer.'
  
  accionPendiente = async () => {
    const resultado = await fichaStore.eliminarFicha(id)
    
    if (resultado) {
      mostrarMensaje('Ficha eliminada exitosamente', 'positivo')
      await cargarFichas()
    } else {
      mostrarMensaje('Error al eliminar la ficha', 'error')
    }
  }

  showConfirmacion.value = true
}

function confirmarAccion() {
  showConfirmacion.value = false
  if (accionPendiente) {
    accionPendiente()
    accionPendiente = null
  }
}

function cancelarAccion() {
  showConfirmacion.value = false
  accionPendiente = null
}

function onFileSelected(event: Event) {
  const input = event.target as HTMLInputElement
  const file = input.files?.[0]
  if (file) {
    archivoSeleccionado.value = file
  }
}

function quitarArchivo() {
  archivoSeleccionado.value = null
  if (fileInputRef.value) fileInputRef.value.value = ''
}

function reutilizarFicha(f: Ficha) {
  archivoSeleccionado.value = null
  if (fileInputRef.value) fileInputRef.value.value = ''
  formData.value = {
    id_instrumento: formData.value.id_instrumento,
    estado: f.estado ?? '',
    documento: (f.documento && f.documento !== 'sin-documento' && f.documento !== 'pendiente-upload')
      ? f.documento
      : '',
    fuente_datos: f.fuente_datos ?? '',
    detalle: f.detalle ?? '',
    observaciones: f.observaciones ?? '',
    descripcion: f.descripcion ?? '',
    fecha_registro: new Date().toISOString().split('T')[0]
  }
  document.querySelector<HTMLElement>('.ficha-form')?.scrollIntoView({ behavior: 'smooth' })
}

async function subirArchivo(idFicha: number, event: Event) {
  const input = event.target as HTMLInputElement
  const file = input.files?.[0]
  if (!file || !idFicha) return

  subiendo.value = idFicha
  try {
    const result = await fichaStore.uploadArchivo(idFicha, file)
    if (result.ok) {
      mostrarMensaje('Archivo subido exitosamente', 'positivo')
    } else {
      mostrarMensaje(result.error || 'Error al subir archivo', 'error')
    }
    await cargarFichas()
  } finally {
    subiendo.value = null
    input.value = ''
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[9] || (_cache[9] = _createElementVNode("h2", { class: "titulo-ficha" }, "Ficha Documental", -1)),
        _createElementVNode("button", {
          class: "btn salir",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.idInstrumento != null ? emit('cerrar') : _unref(router).back()))
        }, _toDisplayString(_ctx.idInstrumento != null ? 'Cerrar' : 'Volver'), 1)
      ]),
      (_ctx.nombreVersion || _ctx.rutaComponente?.length || _ctx.nombreIndicador)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (_ctx.nombreVersion)
              ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.nombreVersion), 1))
              : _createCommentVNode("", true),
            (_ctx.rutaComponente?.length)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.rutaComponente, (nodo, i) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: i,
                    class: "ctx-ruta-nodo"
                  }, [
                    (nodo.tipo)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(nodo.tipo), 1))
                      : _createCommentVNode("", true),
                    (nodo.ordinal)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(nodo.ordinal), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("span", _hoisted_8, _toDisplayString(nodo.nombre), 1)
                  ]))
                }), 128))
              : _createCommentVNode("", true),
            (_ctx.nombreIndicador)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _cache[10] || (_cache[10] = _createElementVNode("span", { class: "ctx-ruta-tipo" }, "Indicador", -1)),
                  _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.nombreIndicador), 1)
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _cache[11] || (_cache[11] = _createElementVNode("div", { class: "divider" }, null, -1))
    ]),
    _createElementVNode("div", _hoisted_11, [
      (loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, "Cargando fichas..."))
        : (fichasUnicas.value.length)
          ? (_openBlock(), _createElementBlock("table", _hoisted_13, [
              _cache[12] || (_cache[12] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", null, "NO."),
                  _createElementVNode("th", null, "ESTADO"),
                  _createElementVNode("th", null, "DOCUMENTO"),
                  _createElementVNode("th", null, "DETALLE"),
                  _createElementVNode("th", null, "ACCIÓN")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fichasUnicas.value, (f, i) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: f.id_ficha
                  }, [
                    _createElementVNode("td", null, _toDisplayString(i + 1), 1),
                    _createElementVNode("td", null, [
                      _createElementVNode("span", {
                        class: _normalizeClass(['semaforo', estadoClass(f.estado)])
                      }, _toDisplayString(estados[f.estado as keyof typeof estados] || f.estado), 3)
                    ]),
                    _createElementVNode("td", _hoisted_14, [
                      (renombrandoId.value === f.id_ficha)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((nuevoNombre).value = $event)),
                              class: "input-nombre",
                              onKeyup: [
                                _withKeys(($event: any) => (guardarNombre(f.id_ficha!)), ["enter"]),
                                _withKeys(cancelarRename, ["escape"])
                              ],
                              placeholder: "Nombre del documento"
                            }, null, 40, _hoisted_16), [
                              [_vModelText, nuevoNombre.value]
                            ]),
                            _createElementVNode("button", {
                              class: "btn guardar btn-sm-accion",
                              onClick: ($event: any) => (guardarNombre(f.id_ficha!))
                            }, "OK", 8, _hoisted_17),
                            _createElementVNode("button", {
                              class: "btn salir btn-sm-accion",
                              onClick: cancelarRename
                            }, "✕")
                          ]))
                        : (f.origen_documento === 'cloudinary' || f.origen_documento === 'externo')
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createElementVNode("a", {
                                href: f.documento,
                                target: "_blank",
                                rel: "noopener",
                                class: "link-doc"
                              }, _toDisplayString(f.nombre_visible || 'Ver documento'), 9, _hoisted_18),
                              (f.url_descarga && f.origen_documento === 'cloudinary')
                                ? (_openBlock(), _createElementBlock("a", {
                                    key: 0,
                                    href: f.url_descarga,
                                    class: "link-descargar",
                                    title: `Descargar ${f.nombre_visible || 'archivo'}`
                                  }, "⬇", 8, _hoisted_19))
                                : _createCommentVNode("", true),
                              (f.origen_documento === 'externo')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_20, "externo"))
                                : _createCommentVNode("", true),
                              (f.formato)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(f.formato.toUpperCase()), 1))
                                : _createCommentVNode("", true)
                            ], 64))
                          : (f.origen_documento === 'desconocido')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_22, "No disponible"))
                            : (!f.origen_documento && f.documento && f.documento !== 'sin-documento' && f.documento !== 'pendiente-upload')
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 3,
                                  href: f.documento,
                                  target: "_blank",
                                  rel: "noopener",
                                  class: "link-doc"
                                }, "Ver documento", 8, _hoisted_23))
                              : (_openBlock(), _createElementBlock("span", _hoisted_24, "-"))
                    ]),
                    _createElementVNode("td", null, _toDisplayString(f.detalle), 1),
                    _createElementVNode("td", _hoisted_25, [
                      (!fichasRecienCreadas.value.includes(f.id_ficha!))
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "btn guardar btn-sm-accion",
                            onClick: ($event: any) => (reutilizarFicha(f))
                          }, "Reutilizar", 8, _hoisted_26))
                        : _createCommentVNode("", true),
                      (f.id_ficha && renombrandoId.value !== f.id_ficha && f.documento && f.documento !== 'sin-documento' && f.documento !== 'pendiente-upload')
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            class: "btn guardar btn-sm-accion",
                            onClick: ($event: any) => (iniciarRenombrar(f))
                          }, "Renombrar", 8, _hoisted_27))
                        : _createCommentVNode("", true),
                      _createElementVNode("label", {
                        class: _normalizeClass(["btn guardar btn-upload", { disabled: subiendo.value === f.id_ficha }])
                      }, [
                        _createTextVNode(_toDisplayString(subiendo.value === f.id_ficha ? 'Subiendo...' : 'Subir archivo') + " ", 1),
                        _createElementVNode("input", {
                          type: "file",
                          accept: ".pdf,.doc,.docx,.xls,.xlsx,.csv,.png,.jpg,.jpeg,.txt",
                          hidden: "",
                          disabled: subiendo.value === f.id_ficha,
                          onChange: ($event: any) => (subirArchivo(f.id_ficha!, $event))
                        }, null, 40, _hoisted_28)
                      ], 2),
                      _createElementVNode("button", {
                        class: "btn salir",
                        onClick: ($event: any) => (abrirConfirmacionEliminar(f.id_ficha))
                      }, "Eliminar", 8, _hoisted_29)
                    ])
                  ]))
                }), 128))
              ])
            ]))
          : (_openBlock(), _createElementBlock("p", _hoisted_30, "No hay fichas registradas."))
    ]),
    _createElementVNode("form", {
      class: "ficha-form",
      onSubmit: _withModifiers(guardarFicha, ["prevent"])
    }, [
      _cache[19] || (_cache[19] = _createElementVNode("h3", null, "Nueva Ficha", -1)),
      _createElementVNode("div", _hoisted_31, [
        _cache[13] || (_cache[13] = _createElementVNode("label", null, "Estado del documento *", -1)),
        _createElementVNode("div", _hoisted_32, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['existe', 'actualizable', 'no_existe'], (key) => {
            return _createElementVNode("label", {
              key: key,
              class: "radio-label"
            }, [
              _withDirectives(_createElementVNode("input", {
                type: "radio",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.estado) = $event)),
                value: key,
                required: ""
              }, null, 8, _hoisted_33), [
                [_vModelRadio, formData.value.estado]
              ]),
              _createElementVNode("span", {
                class: _normalizeClass(['indicador', `semaforo-${key}`])
              }, null, 2),
              _createTextVNode(" " + _toDisplayString(estados[key as keyof typeof estados]), 1)
            ])
          }), 64))
        ])
      ]),
      _createElementVNode("div", _hoisted_34, [
        _cache[15] || (_cache[15] = _createElementVNode("label", null, "Subir archivo de evidencia", -1)),
        _createElementVNode("div", {
          class: _normalizeClass(["upload-area", { disabled: formData.value.estado === 'no_existe' }])
        }, [
          _createElementVNode("label", {
            class: _normalizeClass(["upload-label", { disabled: formData.value.estado === 'no_existe' }])
          }, [
            _createElementVNode("input", {
              type: "file",
              ref_key: "fileInputRef",
              ref: fileInputRef,
              accept: ".pdf,.doc,.docx,.xls,.xlsx,.csv,.png,.jpg,.jpeg,.txt",
              hidden: "",
              disabled: formData.value.estado === 'no_existe',
              onChange: onFileSelected
            }, null, 40, _hoisted_35),
            _cache[14] || (_cache[14] = _createElementVNode("span", { class: "upload-icon" }, "📎", -1)),
            (archivoSeleccionado.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_36, _toDisplayString(archivoSeleccionado.value.name), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_37, "Seleccionar archivo (PDF, DOC, XLS, IMG, etc.)"))
          ], 2),
          (archivoSeleccionado.value)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "btn-quitar",
                onClick: quitarArchivo
              }, "Quitar"))
            : _createCommentVNode("", true)
        ], 2)
      ]),
      _createElementVNode("div", _hoisted_38, [
        _createElementVNode("label", null, "O enlace del documento " + _toDisplayString(!archivoSeleccionado.value && formData.value.estado !== 'no_existe' ? '*' : ''), 1),
        _withDirectives(_createElementVNode("input", {
          type: "url",
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.documento) = $event)),
          disabled: formData.value.estado === 'no_existe' || !!archivoSeleccionado.value,
          placeholder: "https://...",
          class: "form-control"
        }, null, 8, _hoisted_39), [
          [_vModelText, formData.value.documento]
        ]),
        (archivoSeleccionado.value)
          ? (_openBlock(), _createElementBlock("small", _hoisted_40, "El enlace se generará automáticamente al subir el archivo."))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_41, [
        _createElementVNode("label", null, "Fuente de datos " + _toDisplayString(formData.value.estado !== 'no_existe' ? '*' : ''), 1),
        _withDirectives(_createElementVNode("input", {
          type: "text",
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.value.fuente_datos) = $event)),
          disabled: formData.value.estado === 'no_existe',
          placeholder: "De dónde obtuvieron la información",
          class: "form-control"
        }, null, 8, _hoisted_42), [
          [_vModelText, formData.value.fuente_datos]
        ])
      ]),
      _createElementVNode("div", _hoisted_43, [
        _cache[16] || (_cache[16] = _createElementVNode("label", null, "Detalle de la ficha", -1)),
        _withDirectives(_createElementVNode("textarea", {
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.value.detalle) = $event)),
          disabled: formData.value.estado === 'no_existe',
          placeholder: "Explicación del documento",
          class: "form-control"
        }, null, 8, _hoisted_44), [
          [_vModelText, formData.value.detalle]
        ])
      ]),
      _createElementVNode("div", _hoisted_45, [
        _cache[17] || (_cache[17] = _createElementVNode("label", null, "Observaciones", -1)),
        _withDirectives(_createElementVNode("textarea", {
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.value.observaciones) = $event)),
          disabled: formData.value.estado === 'no_existe',
          placeholder: "Notas adicionales",
          class: "form-control"
        }, null, 8, _hoisted_46), [
          [_vModelText, formData.value.observaciones]
        ])
      ]),
      _createElementVNode("div", _hoisted_47, [
        _createElementVNode("button", {
          type: "button",
          class: "btn salir",
          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.idInstrumento != null ? emit('cerrar') : _unref(router).back()))
        }, _toDisplayString(_ctx.idInstrumento != null ? 'Cerrar' : 'Volver'), 1),
        _cache[18] || (_cache[18] = _createElementVNode("button", {
          type: "submit",
          class: "btn guardar"
        }, "Guardar Ficha", -1))
      ])
    ], 32),
    _createVNode(MensajeConfirmacion, {
      visible: showConfirmacion.value,
      title: tituloConfirmacion.value,
      message: mensajeConfirmacion.value,
      confirmText: "Confirmar",
      cancelText: "Cancelar",
      onConfirm: confirmarAccion,
      onCancel: cancelarAccion
    }, null, 8, ["visible", "title", "message"]),
    _createVNode(MensajeFlotante, {
      visible: mensajeVisible.value,
      mensaje: mensajeTexto.value,
      tipo: mensajeTipo.value,
      onCerrar: _cache[8] || (_cache[8] = ($event: any) => (mensajeVisible.value = false))
    }, null, 8, ["visible", "mensaje", "tipo"])
  ]))
}
}

})